import React, { Component } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Typical from "react-typical";
import Video from "./video2.jsx";
import VideoLightbox from "./videoLightbox.jsx";
import { useLanguage } from "../../context/LanguageContext.js";
import { en } from "../../content/translations/en.js";
import { zh } from "../../content/translations/zh.js";

gsap.registerPlugin(ScrollTrigger);

// Functional wrapper so the class can receive translations via props
function HeroWithLang(props) {
  const { lang } = useLanguage();
  const t = lang === "zh" ? zh : en;
  return <HeroInner {...props} t={t} />;
}

class HeroInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstVideoLoaded: false,
      srcs: [[]],
      videoLightbox: false,
    };
  }

  watchVideo(e) {
    this.setState({ videoLightbox: true });
    document.body.style.overflow = "hidden";
  }

  stopVideo(e) {
    this.setState({ videoLightbox: false });
    document.body.style.overflow = "visible";
  }

  async loadVideos() {
    const res = await import("../../content/videos_content.jsx");
    this.setState({ srcs: res.bgvideos });
  }

  componentDidMount() {
    this.loadVideos();
  }

  render() {
    const { t } = this.props;
    return (
      <div
        ref={this.props.refprop}
        id="hero"
        className="flex content-center justify-center"
      >
        {this.state.videoLightbox ? (
          <VideoLightbox closeCallback={(e) => this.stopVideo(e)} t={t} />
        ) : null}
        <div className="hero_element">
          <Video
            srcs={this.state.srcs}
            videoLightbox={this.state.videoLightbox}
            callbackVideoPlaying={() => {
              this.setState(
                { firstVideoLoaded: true },
                this.props.callbackVideoPlaying()
              );
            }}
          />
        </div>
        <div className={this.state.videoLightbox ? "o-0" : ""}>
          {this.state.firstVideoLoaded ? (
            <Typical
              key={t.hero.coverText.join(",")}
              className={"b tc1 bgt br3 pa2 coverText pa3 mt4-m textShadow"}
              steps={t.hero.coverText}
              loop={Infinity}
              wrapper="div"
            />
          ) : null}
        </div>
        <div className="ctaContainer flex flex-column items-center flex-row-ns pb4 pb1-ns">
          <div
            key={0}
            className="ctaItem flex items-center pointer w-100 ma3 mb5-l mb4-m f4-l f5 grow br2 ba bw1 ph3 pv2 dib white bg-black-30 hover-bg-black-60 bgblur"
            onClick={(e) => this.watchVideo(e)}
          >
            <span className="pr2 nowrap tc center">{t.hero.videoCta}</span>
            <span className="w2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-play-btn" viewBox="0 0 16 16">
                <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
              </svg>
            </span>
          </div>
          <div
            key={1}
            className="ctaItem flex items-center pointer w-100 ma3 mb5-l mb4-m f4-l f5 grow br2 ba bw1 ph3 pv2 dib white bg-black-30 hover-bg-black-60 bgblur"
            onClick={(function (ref) {
              return function () {
                ref.scrollIntoView({ behavior: "smooth" });
              };
            })(this.props.ctaRefs.current)}
          >
            <span className="pr2 nowrap tc center">{t.hero.cta}</span>
            <span className="w2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-arrow-down-square" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V4.5z" />
              </svg>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default HeroWithLang;
